"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZINDEX = exports.KEY_VALUES = exports.DEFAULT_LOCALE = exports.ANIMATION_INTERVAL = void 0;
var KEY_VALUES = exports.KEY_VALUES = {
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  TAB: 'Tab',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: ' ',
  PAGEUP: 'PageUp',
  PAGEDOWN: 'PageDown',
  END: 'End',
  HOME: 'Home',
  LEFTARROW: 'ArrowLeft',
  UPARROW: 'ArrowUp',
  RIGHTARROW: 'ArrowRight',
  DOWNARROW: 'ArrowDown',
  NUMBER0: '0',
  NUMBER9: '9',
  DASH: '-',
  PERIOD: '.'
};
var ZINDEX = exports.ZINDEX = /*#__PURE__*/function (ZINDEX) {
  ZINDEX["LAYER1"] = "layer-1";
  ZINDEX["LAYER2"] = "layer-2";
  ZINDEX["LAYER3"] = "layer-3";
  ZINDEX["LAYER4"] = "layer-4";
  ZINDEX["LAYER5"] = "layer-5";
  ZINDEX["LAYER6"] = "layer-6";
  ZINDEX["LAYER7"] = "layer-7";
  ZINDEX["LAYER8"] = "layer-8";
  ZINDEX["LAYER_BOTTOM"] = "layer-bottom";
  ZINDEX["LAYER_MODAL"] = "layer-modal";
  ZINDEX["LAYER_TOOLTIP"] = "layer-tooltip";
  ZINDEX["LAYER_TOP"] = "layer-top";
  return ZINDEX;
}({});
var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en_US';
var ANIMATION_INTERVAL = exports.ANIMATION_INTERVAL = {
  FADE_IN_OUT: 350
};